module.exports = __webpack_public_path__ + "static/media/trophy-icon.86356fdd.png";